export interface UpdateContext {
  section: string;
  hidden: boolean;
  editing: boolean;
  dialog: boolean;
  downloading: boolean;
  playing: boolean;
}
export function canUpdate(context: UpdateContext): boolean {
  return !['reader', 'anime', 'live', 'appearance', 'more', 'sources'].includes(context.section)
    && !context.hidden && !context.editing && !context.dialog && !context.downloading && !context.playing;
}
